import React from 'react'
import { Redirect } from 'react-router-dom'
import { canAccessBridgeAdminRoute } from 'src/utils/bridgeAdminNav'

/**
 * OMS platform-admin gate for The Bridge (same strict isAdmin check as Spartacus).
 */
const BridgeRoute = ({ account, children }) => {
  if (!canAccessBridgeAdminRoute(account)) {
    return <Redirect to='/admin/orders' />
  }

  return <>{children}</>
}

export default BridgeRoute
